import * as Hybird from '@shareit/shareit-hybird-js-sdk/lib/hybird.umd';
window.Hybird = Hybird.default;